import { SoundSrc, UserRecordedSoundSrc } from '@/store/modules/play/types'

const effects: SoundSrc[] = [
  {
    soundId: 'train1',
    label: 'GSE警笛音',
    src: 'assets/sound/0212_1-GSE-horn-7.wav',
    icon: 'assets/key/train01.png',
    keyImage: 'assets/key/train01.png',
    color: '#d5cdec',
    beatLength: 7,
  },
  {
    soundId: 'train2',
    label: '警笛音',
    src: 'assets/sound/0212_2-horn-4.wav',
    icon: 'assets/key/train02.png',
    keyImage: 'assets/key/train02.png',
    color: '#eacaeb',
    beatLength: 4,
  },
  {
    soundId: 'train-door',
    label: 'ドア開閉',
    src: 'assets/sound/0305_3-train-door-4.wav',
    icon: 'assets/key/train03.png',
    keyImage: 'assets/key/train03.png',
    color: '#f8adb9',
    beatLength: 4,
  },
  {
    soundId: 'train-running',
    label: 'ガタンゴトン',
    src: 'assets/sound/0305_4-train-running-4.wav',
    icon: 'assets/key/train04.png',
    keyImage: 'assets/key/train04.png',
    color: '#fba294',
    beatLength: 4,
  },
  {
    soundId: 'call-for-departure',
    label: '出発進行',
    src: 'assets/sound/0212_5-call-for-departure-4.wav',
    icon: 'assets/key/station-employee-man.png',
    keyImage: 'assets/key/station-employee-man.png',
    color: '#f6b593',
    beatLength: 4,
  },
  {
    soundId: 'soon-ebina',
    label: 'まもなく海老名',
    src: 'assets/sound/0212_6-soon-ebina-7.wav',
    icon: 'assets/key/station-employee-woman.png',
    keyImage: 'assets/key/station-employee-woman.png',
    color: '#f6c28a',
    beatLength: 7,
  },
  {
    soundId: 'crossing',
    label: '踏切',
    src: 'assets/sound/0212_7-crossing-4.wav',
    icon: 'assets/key/crossing.png',
    keyImage: 'assets/key/crossing.png',
    color: '#f6cc73',
    beatLength: 4,
  },
  {
    soundId: 'robot',
    label: 'ロボット',
    src: 'assets/sound/0212_16-robot-3.wav',
    icon: 'assets/key/robot.png',
    keyImage: 'assets/key/robot.png',
    color: '#fbdc60',
    beatLength: 3,
  },
  {
    soundId: 'guitar',
    label: 'ギター',
    src: 'assets/sound/0212_8-guitar-3.wav',
    icon: 'assets/key/guitar.png',
    keyImage: 'assets/key/guitar.png',
    color: '#dde586',
    beatLength: 3,
  },
  {
    soundId: 'bass',
    label: 'ベース',
    src: 'assets/sound/0303_9-bass-4.wav',
    icon: 'assets/key/bass.png',
    keyImage: 'assets/key/bass.png',
    color: '#cfeda5',
    beatLength: 4,
  },
  {
    soundId: 'drum',
    label: 'ドラム',
    src: 'assets/sound/0212_10-drum-4.wav',
    icon: 'assets/key/drum.png',
    keyImage: 'assets/key/drum.png',
    color: '#b8deac',
    beatLength: 4,
  },
  {
    soundId: 'piano',
    label: 'ピアノ',
    src: 'assets/sound/0310_11-piano-4.mp3',
    icon: 'assets/key/piano.png',
    keyImage: 'assets/key/piano.png',
    color: '#a4dfd0',
    beatLength: 4,
  },
  {
    soundId: 'maracas',
    label: 'マラカス',
    src: 'assets/sound/0212_12-maracas-2.wav',
    icon: 'assets/key/maracas.png',
    keyImage: 'assets/key/maracas.png',
    color: '#b4eeef',
    beatLength: 2,
  },
  {
    soundId: 'dog',
    label: '犬',
    src: 'assets/sound/0212_13_dog-1.wav',
    icon: 'assets/key/dog.png',
    keyImage: 'assets/key/dog.png',
    color: '#a3e1f0',
    beatLength: 1,
  },
  {
    soundId: 'cat',
    label: '猫',
    src: 'assets/sound/0212_14-cat-2.wav',
    icon: 'assets/key/cat.png',
    keyImage: 'assets/key/cat.png',
    color: '#8bdaf9',
    beatLength: 2,
  },
  {
    soundId: 'dj',
    label: 'スクラッチ音',
    src: 'assets/sound/0212_15-dj-3.wav',
    icon: 'assets/key/dj.png',
    keyImage: 'assets/key/dj.png',
    color: '#97ccf2',
    beatLength: 3,
  },
]

const userRecorded: UserRecordedSoundSrc = {
  soundId: 'user-recorded',
  label: '',
  icon: 'assets/sound-icon/user-recorded.png',
  keyImage: 'assets/key/user-recorded.png',
  color: '#0b6eb6',
  // 3秒を拍に変換（3秒 / 1小節の秒数 * 拍数の4）
  // 3 / 1.611 * 4 を丸める
  beatLength: 7.45,
  hasAudioBuffer: false,
}

const bgm: SoundSrc[] = [{
  soundId: 'bgm',
  label: '小田急ピポー',
  src: 'assets/sound/odakyu-pipo-for-playing.mp3',  // https://app.box.com/folder/132670589421
}]

export {
  effects,
  userRecorded,
  bgm,
}
